export const DEVICE_TYPES = {
  MOBILE: 'mobile',
  DESKTOP: 'desktop',
  NATIVE: 'native',
  TABLET: 'tablet',
} as const

export type DEVICE_TYPE = (typeof DEVICE_TYPES)[keyof typeof DEVICE_TYPES]
